import { create } from 'zustand'
import { TimeProps } from '../../lib'

export interface StoreProps extends TimeProps {
  expired: boolean
  intervalIds: NodeJS.Timeout[]
  startCountdown: (countDownDate?: Date, ms?: number) => void
}

export const getDateInSeconds = (seconds: number) => {
  const countDownDate = new Date()
  countDownDate.setSeconds(countDownDate.getSeconds() + seconds)
  return countDownDate
}

const initStoreState = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  expired: false,
  intervalIds: [],
}

const useStore = create<StoreProps>((set, get) => ({
  ...initStoreState,
  startCountdown: (countDownDate: Date = getDateInSeconds(60), ms = 1000) => {
    const resetCountdown = () => {
      const intervalIds = get().intervalIds
      intervalIds.map((id) => clearInterval(id))
      set({ ...initStoreState })
    }

    const updateCountdown = () => {
      const intervalId = get().intervalIds?.[0]
      const now = new Date().getTime()
      const distance = Math.round(countDownDate.getTime() - now)

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      if (distance <= 0 && intervalId) {
        clearInterval(intervalId)
        return
      }

      set({
        days,
        hours,
        minutes,
        seconds,
        expired: distance < 0,
      })
    }

    resetCountdown()
    const intervalIdInit = setInterval(updateCountdown, 0)
    const intervalId = setInterval(updateCountdown, ms)
    set({ intervalIds: [intervalId, intervalIdInit] })
  },
}))

export default useStore
